module.exports = "<p>\n  successdialog works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/successdialog/successdialog.component.html
// module id = ./src/app/components/successdialog/successdialog.component.html
// module chunks = main